import React from 'react';
import { connect } from 'react-redux';
import PaymentPageSettingModal from './PaymentPageSettingModal';
import { actions } from './PaymentPageSettingModal.actions';

const PaymentPageSettingModalComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            savePaymentAccount: actions.savePaymentAccount
        };
    }
)(PaymentPageSettingModal);

export default PaymentPageSettingModalComponent;
